import { gql } from "@apollo/client";

export const POST_STAFFS = gql`
  mutation ($businessId: ID, $businessStaffs: [StaffInput]) {
    createStaffs(businessId: $businessId, staffs: $businessStaffs) {
      id
      name
    }
  }
`;

export const POST_STAFF = gql`
  mutation ($businessId: ID, $businessStaff: StaffInput) {
    createStaff(businessId: $businessId, businessStaff: $businessStaff) {
      id 
      status
      image
      { 
        url
      }
      staffApproveId
      user {
        id
        username
        email
         timeZone {
        id,
        timezone
        }
      }
      workingHourGroups {
        id
        title
        def
        custom
        workingHours {
          id
          groupId
          day
          onJob
          startTime
          endTime
        }
      }
    }
  }
`;

export const DELETE_STAFF = gql`
  mutation ($staffId: ID) {
    deleteStaff(staffId: $staffId) {
      id
    }
  }
`;

export const UPDATE_STAFF = gql`
  mutation ($staffId: ID, $businessStaff: UpdateStaffInput) {
    updateStaff(staffId: $staffId, staff: $businessStaff) {
    status
      id
      url
      showGoogleEvents
      image {
        id
        url
        staffId
      }
      subscription {
        id
        planId
      }
      workingHourGroups {
        id
        title
        def
        custom
        isForBusiness
        timeZone {
          id
          timezone
        }
        workingHours {
          id
          groupId
          day
          onJob
          startTime
          endTime
          parentId
        }
        workingHourOverrideGroups {
          id
          groupId
          startDate
          endDate
          title
          workingHourOverrides {
            id
            whOverrideGroupId
            startTime
            endTime
          }
        }
      }
      user {
        id
        email
        username
        timeZone {
          id
          timezone
        }
      }
      role {
        id
        name
        permissions
      }
    }
  }
`;
